import script from "./CarbonAds.vue?vue&type=script&lang=jsx"
export * from "./CarbonAds.vue?vue&type=script&lang=jsx"

import "./CarbonAds.vue?vue&type=style&index=0&id=20842ae5&lang=less"

const __exports__ = script;

export default __exports__